import { Component, Input, Output, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";
import { ProgramService } from "../program.service";
import { MessageService } from "primeng/components/common/messageservice";

import {ActNowDictionaryItem} from "@models/common";
import { Program } from "models/program";

declare var Sifter: any;

@Component({
    selector: "app-merge-tool",
    templateUrl: "./merge-tool.component.html"
})

export class MergeToolComponent {

    @Input() parentProgram: Program;
    @Output() parentMerged = new EventEmitter<void>();

    public mergeToolModal: boolean = false;
    public program1Input: ActNowDictionaryItem;
    public program2Input: ActNowDictionaryItem;
    public programList: ActNowDictionaryItem[];
    public programResults: ActNowDictionaryItem[];
    // public mergeToolModal: boolean = false;

    constructor(
        private programService: ProgramService,
        private messageService: MessageService,
        private router: Router

    ) {}

    searchProgram(event) {
        this.programService.programMergeQuery(event.query).subscribe(data => {
            this.programResults = data;
        });
    }

    swapPrograms() {
        let temp = this.program1Input;
        this.program1Input = this.program2Input;
        this.program2Input = temp;
    }

    validate(): boolean {
        if (this.program1Input == undefined || this.program1Input.id == undefined) {
            this.messageService.add({severity: "error", summary: "Error", detail: "Please select an option for Program 1"});
            return false;
        }
        if (this.program2Input == undefined || this.program2Input.id == undefined) {
            this.messageService.add({severity: "error", summary: "Error", detail: "Please select an option for Program 2"});
            return false;
        }
        if (this.program1Input.id === this.program2Input.id) {
            this.messageService.add({severity: "error", summary: "Error", detail: "Program 1 and Program 2 cannot be the same"});
            return false;
        }
        return true;
    }

    mergePrograms() {
        if (this.validate()) {
            this.programService.mergePrograms(this.program1Input, this.program2Input).subscribe(
                response => {
                    this.messageService.add({ severity: "success", summary: "Success", detail: response.message });
                    this.mergeToolModal = false;
                    this.parentMerged.emit();
                    if (this.parentProgram.id === this.program2Input.id) { this.router.navigate(["/program-list/"]); }

                },
                error => {
                    this.messageService.add({ severity: "error", summary: "Error", detail: "There was an issue merging the programs" });
                });
        }
    }

    externalModalShow() {
        this.mergeToolModal = true;
        if (this.parentProgram) {
            this.program1Input = new ActNowDictionaryItem;
            this.program1Input.id = this.parentProgram.id;
            this.program1Input.text = this.parentProgram.contactInfo.name;
         }
    }

}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/programs/merge-tool/merge-tool.component.ts